import { TranslationsHelper } from './translation.helper';

export const CurrencyHelper = {
  format: (value, language) => {
    const numValue = +value ?? 0;
    return TranslationsHelper.translate(language, `SAR ${numValue.toFixed(2)}`, `${numValue.toFixed(2)} ر.س`);
  },
};
